import React from 'react';

const VIEW_LABELS = {
    lifetime: 'Lifetime',
    ytd: 'YTD',
    month: 'Maand',
    timeline: 'Alle maanden',
};

export default function TablePagePeriodToggles({ viewKeys, viewModes, onToggle, busy = false }) {
    return (
        <>
            <label>Periode:</label>
            <div
                className={`project-period-options${busy ? ' project-period-options--busy' : ''}`}
            >
                {viewKeys.map(key => (
                    <label key={key} className="project-period-option">
                        <input
                            type="checkbox"
                            checked={Boolean(viewModes[key])}
                            disabled={busy}
                            onChange={() => onToggle(key)}
                        />
                        {VIEW_LABELS[key] || key}
                    </label>
                ))}
            </div>
        </>
    );
}
